/**
 * PRP-MCP-5: the small "from chat" tag on a line, room or estimate that a chat
 * app (Claude, ChatGPT) changed, until that change is undone.
 */
import { Pill } from './ui/pill';

export default function ChatTag({ className }: { className?: string }) {
  return (
    <span data-testid="chat-tag" className={`inline-flex align-middle ${className ?? ''}`}>
      <Pill kind="accent" className="!h-[16px] !px-[6px] !text-[10px]">
        from chat
      </Pill>
    </span>
  );
}
